import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const TradingStyleContext = createContext(null);
const LOCAL_KEY = "qsp_trading_style";

export function TradingStyleProvider({ children }) {
  const { user } = useAuth();
  // 'SWING' | 'INTRADAY'
  const [style, setStyleState] = useState(() => {
    return localStorage.getItem(LOCAL_KEY) || "SWING";
  });
  const [loading, setLoading] = useState(false);

  // Hydrate from server when user logs in
  useEffect(() => {
    let cancelled = false;
    if (!user || typeof user !== "object") return;
    setLoading(true);
    api.get("/auth/preferences")
      .then((r) => {
        if (cancelled) return;
        const server = r?.data?.trading_style;
        if (server === "SWING" || server === "INTRADAY") {
          setStyleState(server);
          localStorage.setItem(LOCAL_KEY, server);
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [user]);

  const setStyle = useCallback(async (next) => {
    if (next !== "SWING" && next !== "INTRADAY") return;
    setStyleState(next);
    localStorage.setItem(LOCAL_KEY, next);
    // Persist to server (fire-and-forget)
    try {
      await api.put("/auth/preferences", { trading_style: next });
    } catch (_) {}
  }, []);

  return (
    <TradingStyleContext.Provider value={{ style, setStyle, loading }}>
      {children}
    </TradingStyleContext.Provider>
  );
}

export const useTradingStyle = () => useContext(TradingStyleContext);
